export default __webpack_public_path__ + "static/media/developer__icon.11d5e05a.png";